import { useCallback, useSyncExternalStore } from 'react'

import socketService from '../api/socketService'

export const useSocket = () => {
  const socket = useSyncExternalStore(
    socketService.subscribe.bind(socketService),
    () => socketService.getSocket(),
    () => null,
  )

  const isConnected = useSyncExternalStore(
    socketService.subscribe.bind(socketService),
    () => socketService.isSocketConnected(),
    () => false,
  )

  const connect = useCallback(() => {
    socketService.connect()
  }, [])

  const disconnect = useCallback(() => {
    socketService.disconnect()
  }, [])

  return {
    isConnected,
    connect,
    disconnect,
    socket,
  }
}
